var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPieVerifiedSign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13582",
    "data-name": "Rectangle 13582",
    width: 24,
    height: 24,
    transform: "translate(-3 -4)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_41998",
    "data-name": "Path 41998",
    d: "M16.293,2.569a.716.716,0,0,0-1,0l-8.31,8.168L2.7,6.5a.713.713,0,0,0-1,0L.206,7.974a.689.689,0,0,0,0,.982L6.48,15.165a.72.72,0,0,0,1,0L17.791,5.026a.686.686,0,0,0,0-.986Z",
    transform: "translate(0 -2.366)",
    fill: "#fae79f"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPieVerifiedSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_pie_verified_sign.f6f0c8f06f22ca65c72bf187f9c52e52.svg";